import { BaseMapper, clampPercentage } from '@ps/utils';
import { SurveyQuotaUpdate } from '@ps/survey-utils';

import { QuotaUpdateResultDto } from '../dtos/survey-quota.dto';

export class QuotaUpdateMapper extends BaseMapper<
  QuotaUpdateResultDto,
  SurveyQuotaUpdate
> {
  public fromDto(dto: QuotaUpdateResultDto): SurveyQuotaUpdate {
    return {
      psQuotaId: dto.quota_id,
      goal: dto.quantities.current_target,
      currentlyOpen: dto.quantities.currently_open,
      maximum: dto.quantities.maximum,
      allocationPercentage: clampPercentage(dto.quantities.percentage),
      fielded: dto.quantities.achieved,
      locked: dto.locked,
      suppliers: Object.values(dto.suppliers ?? {}).map((supplier) => ({
        currentTarget: supplier.current_target,
        completeNeeded: supplier.complete_needed,
      })),
    };
  }
}
